import { useEffect, useState, useRef } from 'react'
import { GetChatLog } from '../../services/data'
import DateTimeFormat from '../../util/DateTimeformat'
import IonIcon from '@reacticons/ionicons'
import GetDataSet, { insertdataset } from '../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import '../../styles/conversation.css'
import TooltipWalkthrough from '../../util/walkthrough'
import { useSubscription } from '../../context/subscriptionprovider'
import console_log from '../../util/consolelog'
import { marked } from 'marked'
import { useLocation, useParams } from 'react-router-dom'

// Configure marked to sanitize HTML and add target="_blank" to links
marked.setOptions({
  breaks: true,
  gfm: true,
  sanitize: true,
  renderer: new marked.Renderer({
    link (href, title, text) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" title="${
        title || ''
      }" class="underline">${text}</a>`
    }
  })
})

const LIMIT = 1000 // Load up to 1000 messages

const Conversation = ({ chatlistId }) => {
  const chatLog = new GetChatLog()
  const [messages, setMessages] = useState([])
  const [activeuserId, SetactiveuserId] = useState('')
  const [activeuserMessage, SetactiveuserMessage] = useState('')
  const [showpreviewMessage, SetshowpreviewMessage] = useState(false)
  const [scrollLimit, SetscrollLimit] = useState(false)

  const conversationContainerRef = useRef(null)
  const isFetchingRef = useRef(false)
  const {isRestricted, limitedPermission } = useSubscription()
  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  useEffect(() => {
    console.log('permission', limitedPermission)
  }, [])

  useEffect(() => {
    if (conversationContainerRef.current) {
      const links = conversationContainerRef.current.querySelectorAll('a')
      links.forEach(link => {
        link.classList.add('underline')
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noopener noreferrer')
      })
    }
  }, [messages])

  useEffect(() => {
    if (messages.length > 0) {
      const container = conversationContainerRef.current
      container.scrollTop = container.scrollHeight
    }
  }, [messages])

  useEffect(() => {
    const handleScrollLimit = e => e.detail === true && SetscrollLimit(true)
    const handleScrollLimitend = () => {
      requestAnimationFrame(() => {
        SetscrollLimit(false)
        if (conversationContainerRef.current) {
          conversationContainerRef.current.scrollTop =
            conversationContainerRef.current.scrollHeight
        }
      })
    }

    window.addEventListener('scrollLimit', handleScrollLimit)
    window.addEventListener('tooltip:end', handleScrollLimitend)

    return () => {
      window.removeEventListener('scrollLimit', handleScrollLimit)
      window.removeEventListener('tooltip:end', handleScrollLimitend)
    }
  }, [])

  useEffect(() => {
    const storeId = store_id
    if (!chatlistId || !storeId) return

    const controller = new AbortController()
    const { signal } = controller

    const fetchMessages = async () => {
      if (isFetchingRef.current) return
      isFetchingRef.current = true

      try {
        const response = await chatLog.Get_Chat_Log(
          storeId,
          chatlistId,
          signal,
          1,
          LIMIT
        )

        if (response?.data?.length > 0) {
          console.log(response.data)
          setMessages(response.data)
        } else {
          setMessages([])
        }
      } catch (error) {
        console.error('Error fetching conversation:', error)
      } finally {
        isFetchingRef.current = false
      }
    }

    fetchMessages()

    const handleEvents = e => {
      if (e?.detail?.success || e?.detail === true) fetchMessages()
    }

    const events = [
      'chatlist_customer_id',
      'loadchatlist',
      'deletereload',
      'chatagent'
    ]
    events.forEach(event => window.addEventListener(event, handleEvents))

    return () => {
      events.forEach(event => window.removeEventListener(event, handleEvents))
      controller.abort()
    }
  }, [chatlistId])

  const handleactivetrainbot = (userID, userMsg) => {
    if (activeuserId === userID) {
      SetactiveuserId('')
      SetactiveuserMessage('')
    } else {
      SetactiveuserId(userID)
      SetactiveuserMessage(userMsg)
    }
  }

  const handleinsertform = async e => {
    e.preventDefault()
    const content = e.target.content.value
    const data = [
      {
        title: activeuserMessage,
        type: 'unmatched',
        status: 'inactive',
        store_id: store_id,
        meta: { data: { question: activeuserMessage, answer: content } },
        training_processing: false
      }
    ]

    try {
      const res = await insertdataset(data)
      if (res.success && res.data[0].status === 'inactive') {
        const datasetid = res.data[0].dataset_id
        await new GetDataSet().setTrained([datasetid])
        SetshowpreviewMessage(false)
        SetactiveuserId('')
        SetactiveuserMessage('')
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  // Function to safely parse markdown
  const parseMarkdown = content => {
    try {
      return marked(content || '')
    } catch (error) {
      console.error('Error parsing markdown:', error)
      return content
    }
  }

  return (
    <>
      {showpreviewMessage && (
        <div className='fixed inset-0 bg-black bg-opacity-25 p-5 flex justify-center items-center z-50'>
          <div className='bg-white p-5 sm:p-7 shadow-lg w-full max-w-[900px] mx-auto my-[30px] rounded-[24px] border-[1.6px] overflow-y-auto min-h-[40%] max-h-[90%] scrollbar-hide'>
            <div className='flex justify-between mb-10'>
              <div>
                <h2 className='font-extrabold text-[20px]'>
                  Train Unanswered Question
                </h2>
                <h3 className='text-[16px] text-gray-600'>
                  Trained data will appear in Training &gt; Unanswered
                </h3>
              </div>
              <button
                onClick={() => {
                  SetshowpreviewMessage(false)
                  SetactiveuserId('')
                  SetactiveuserMessage('')
                }}
                className='w-[30px] h-[30px] sm:w-[40px] sm:h-[40px]'
              >
                <svg width='30' height='30' viewBox='0 0 30 30'>
                  <path
                    fill='#373737'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.1 7.8a1 1 0 1 0-1.4 1.4L13.7 15l-6 6a1 1 0 1 0 1.4 1.4L15 16.3l6 6a1 1 0 1 0 1.4-1.4L16.3 15l6-6a1 1 0 0 0-1.4-1.4L15 13.7 9.1 7.8Z'
                  />
                </svg>
              </button>
            </div>
            <form onSubmit={handleinsertform}>
              <input
                type='text'
                name='usermessage'
                className='bg-[#F8F7F7] w-full h-[55px] rounded-[24px] p-5'
                placeholder='Question'
                value={activeuserMessage}
                onChange={e => SetactiveuserMessage(e.target.value)}
              />
              <textarea
                name='content'
                maxLength={2000}
                rows='10'
                placeholder='Answer'
                className='bg-[#F8F7F7] mt-3 w-full h-[180px] rounded-[24px] p-5'
                required
              ></textarea>
              <small className='ml-2'>*Max word limit 2000</small>
              <div className='flex justify-end mt-5'>
                <button
                  type='submit'
                  className='bg-[#7C50DD] text-white py-2 px-10 text-[14px] rounded-[19px]'
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div
        className={`flex flex-col items-center pt-5 pb-9 pl-9 pr-8 w-full scrollbar-custom1 ${
          scrollLimit
            ? 'h-auto'
            : 'max-h-[320px] overflow-x-hidden overflow-y-auto'
        }`}
        ref={conversationContainerRef}
      >
        <div className='w-full max-w-2xl space-y-8'>
          {messages.map((msg, index) => (
            <div
              key={msg.chat_id}
              className={`flex message ${
                msg.role === 'user' ? 'justify-end' : 'justify-start'
              }`}
            >
              <div className='flex space-x-4 items-start max-w-md'>
                <div className='flex flex-col space-y-1'>
                  <div className='flex items-center text-xs text-gray-500 justify-between'>
                    <div className='flex gap-3'>
                      {msg.updatedAt
                        ? new Date(msg.updatedAt).toLocaleString('en-US', {
                            month: 'short', // "Aug"
                            day: 'numeric', // "1"
                            year: 'numeric', // "2025"
                            hour: '2-digit', // "04"
                            minute: '2-digit', // "48"
                            hour12: true // AM/PM
                          })
                        : 'Unknown Date/Time'}
                      <p
                        className={`usertype font-normal text-[#000] ${msg.role}-message`}
                      >
                        {msg.role === 'assistant'
                          ? 'Bot'
                          : msg.role === 'agent'
                          ? 'Agent'
                          : 'User'}
                      </p>
                    </div>
                  </div>
                  <div className='flex flex-col items-start gap-2'>
                    <div
                      className={`px-5 py-4 ${
                        msg.role === 'user'
                          ? 'bg-[#9b6dff] text-white rounded-tl-lg rounded-bl-lg rounded-br-lg'
                          : 'bg-[#F2F2F2] text-[#768396] rounded-tr-lg rounded-br-lg rounded-bl-lg'
                      } text-[12px]`}
                      dangerouslySetInnerHTML={{
                        __html: parseMarkdown(msg?.content ?? '')
                      }}
                    ></div>
                    {msg.role === 'user' &&
                      !isRestricted && (
                        <button
                          data-tooltip-place='top'
                          data-tooltip-id='my-tooltip'
                          data-tooltip-content='This will help improve AI answers without repeating your content. Avoid private info.'
                          className={`px-2 py-2 flex gap-1 items-center justify-center border rounded-[59px] text-[10px] font-semibold
                            ${
                              activeuserId === msg.message_id
                                ? 'bg-[#7C50DD] text-white'
                                : 'bg-white text-black hover:bg-[#7C50DD] hover:text-white'
                            }`}
                          onClick={() => {
                            handleactivetrainbot(msg.message_id, msg.content)
                            SetshowpreviewMessage(true)
                          }}
                        >
                          <IonIcon
                            name='flash-outline'
                            className='text-[12px]'
                          />
                          <p>Train Bot</p>
                        </button>
                      )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ToastContainer />
        <TooltipWalkthrough pageKey={'/chats'} />
      </div>
    </>
  )
}

export default Conversation
